import { FormContainer, LabeledInput, Worksheet } from "uikit"
import HumanTimeSince from "components/HumanTimeSince"
import React from "react"
import { Dropdown, Grid } from "semantic-ui-react"
import { useStore } from "store"
import { AddPersonModal } from "../../../people/AddPersonModal"
import ConnectedAccountBar from "../../ConnectedAccountBar"
import { Footer } from "./Footer"

const BasicWithOwnerForm = ({
  data: {
    fields: { person_id, balance },
    isModified,
    onSubmit,
    error
  },
  submitLabel = "Done",
  ownerOptions,
  isNew,
  onDelete,
  addNewPerson,
  lastUpdatedAt,
  account
}) => (
  <Grid>
    {account.connection_id ? (
      <Grid.Row style={{ borderBottom: "1px solid #ccc" }}>
        <Grid.Column>
          <ConnectedAccountBar {...account} />
        </Grid.Column>
      </Grid.Row>
    ) : null}
    <Grid.Row>
      <Grid.Column>
        <Worksheet error={error} style={{ borderTop: "1px solid #ccc" }}>
          <Worksheet.Body>
            <Worksheet.Row
              label="What is the current balance of this account?"
              description={
                account.connection_id
                  ? "Automatically updated through the account connection"
                  : null
              }
              paddedField
            >
              <Worksheet.Field error={balance.error}>
                <LabeledInput
                  {...balance}
                  label=""
                  iconText="$"
                  iconPosition="left"
                  placeholder="0"
                  disabled={!!account.connection_id}
                  data-testid="balance"
                />
                {lastUpdatedAt}
              </Worksheet.Field>
            </Worksheet.Row>
            <Worksheet.Row label="Who is the account holder/owner?" paddedField>
              <Worksheet.Field error={person_id.error}>
                <Dropdown
                  {...person_id}
                  placeholder="Account Holder"
                  options={ownerOptions}
                  data-testid="accountOwner"
                  selection
                />
                {person_id.value === "__ADD__" && (
                  <AddPersonModal
                    submit={personValues =>
                      addNewPerson(personValues).then(({ personId }) =>
                        person_id.onChange(null, { value: personId })
                      )
                    }
                    onCancel={() => person_id.onChange(null, { value: null })}
                  />
                )}
              </Worksheet.Field>
            </Worksheet.Row>
          </Worksheet.Body>
          <Footer
            isNew={isNew}
            submitLabel={submitLabel}
            onSubmit={onSubmit}
            onDelete={onDelete}
            isModified={isModified}
            deleteLabel={
              account.connection_id ? "Ignore Account" : "Delete Account"
            }
            hasConnectionId={account.connection_id ? true : false}
            error={error}
          />
        </Worksheet>{" "}
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

const BasicWithOwnerFormContainer = FormContainer(
  {
    balance: {
      type: "unit"
    },
    person_id: {
      type: "string"
    }
  },
  (fields, ...form) => {}
)(BasicWithOwnerForm)

const BasicWithOwner = ({ household, account, type, ...formProps }) => {
  const isNew = account === null
  const lastUpdatedAt = !isNew ? (
    <p
      style={{
        fontSize: "0.8em",
        textAlign: "right",
        fontWeight: "normal"
      }}
    >
      Updated <HumanTimeSince time={account.balance_updated_at} /> ago
    </p>
  ) : null
  const [peopleObject, { createPerson }] = useStore(
    "householdPeople",
    household.id
  )
  const people = Object.values(peopleObject)
  // If there's no spouse in household, we fallback to the client's ID
  // for auto-selecting on the dropdown.
  // PS: I couldn't come up with another name for this variable.
  const onlyClientId = people.some(({ role }) => role === "spouse")
    ? ""
    : people.find(({ role }) => role === "client").id
  const values = isNew ? { person_id: onlyClientId } : { ...account }
  let ownerOptions = []
  let canAddOwner = false

  if (type === "brokerage") {
    canAddOwner = false // true
    ownerOptions = people
      .filter(person => person.role === "spouse" || person.role === "client")
      .map(({ id: value, first_name: text }) => ({
        value,
        text
      }))
    if (people.some(({ role }) => role === "spouse")) {
      ownerOptions = ownerOptions.concat({
        value: "null",
        text: "Joint"
      })
    }
    if (values.person_id === null) {
      Object.assign(values, { person_id: "null" })
    }
  } else {
    ownerOptions = people
      .filter(person => person.role === "spouse" || person.role === "client")
      .map(({ id: value, first_name: text }) => ({
        value,
        text
      }))
    canAddOwner = false //ownerOptions.length < 2
  }
  if (canAddOwner) {
    ownerOptions.push({ text: "Add person...", value: "__ADD__" })
  }

  // TODO ACTION
  const addNewPerson = values =>
    createPerson({ household_id: household.id, ...values })
  return (
    <BasicWithOwnerFormContainer
      {...formProps}
      values={values}
      lastUpdatedAt={lastUpdatedAt}
      account={values}
      ownerOptions={ownerOptions}
      addNewPerson={addNewPerson}
    />
  )
}

export default BasicWithOwner
